exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "*{\n    padding: 0;\n    margin: 0;\n}\n\nbutton{\n    background: #32b16c;\n    border-color: #32b16c;\n    color: #fff;\n    display: block;\n    width: 100%;\n    padding: 10px;\n    -webkit-border-radius: 0;\n    -moz-border-radius: 0;\n    border-radius: 0;\n    font-size: 16px;\n}\n\nbutton:link,\nbutton:visited,\nbutton:hover,\nbutton:active,\nbutton:focus{\n    outline: none;\n}\n\n.form-box{\n    padding: 10px;\n    background: #f5f5f5;\n}\n\n.control-box{\n    margin-bottom: 20px;\n}\n\n.control-box:last-child{\n    margin-bottom: 0;\n}\n\n.control-title{\n    color: rgba(0, 0, 0, 0.87);\n    font-size: 16px;\n}\n\n.control-box label{\n    color: rgba(0, 0, 0, 0.54);\n    font-size: 14px;\n    margin-right: 10px;\n}\n\n.control-box input{\n    vertical-align: middle;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./example/src/style.css
// module id = 142
// module chunks = 0